// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-6f349424!./node_modules/sass-loader/dist/cjs.js?{"api":"modern","sassOptions":{"quietDeps":true},"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=3!./src/app/features/courses/pages/premades/livePremadeForm.vue
// module id = 1960
// module chunks = 61